@if (textCTAData) {
  <div
    class="px-8 py-16 md:py-20"
    [ngClass]="{
      'bg-black !text-white': textCTAData.darkBackground,
      'bg-white !text-ss-brown': !textCTAData.darkBackground,
    }"
  >
    <div
      class="flex flex-col md:flex-row justify-center align-center md:mx-16 gap-8 md:gap-32"
    >
      <div class="align-middle mt-auto mb-auto">
        @if (textCTAData.leftSideText) {
          <div
            class="text-center md:text-left mr-8 mt-2"
            [innerHTML]="textCTAData.leftSideText"
            [ssDirectus]="{
              collection: 'textCTA',
              item: textCTAData.id,
              fields: ['leftSideText'],
            }"
          ></div>
        }
      </div>
      @if (textCTAData.rightSideButton) {
        <div class="button-right align-middle mt-auto mb-auto flex space-x-2">
          @for (
            button of textCTAData.rightSideButton;
            track buttons($index, button)
          ) {
            <ss-building-block-button-link
              [buttonLink]="button.item"
              class="flex-1 min-w-max"
            ></ss-building-block-button-link>
          }
        </div>
      }
    </div>
  </div>
}
